"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadingsAfter = exports.hasExpectedReadings = exports.formatPreviousReading = exports.getNextSupplyIndex = exports.scrollTo = exports.countSupplies = exports.countMeters = exports.filterSupplies = exports.filterTimeOfUseLabel = exports.hasNoActiveSupplies = exports.hasComplexElec = exports.timeOfUseLabelToTimingCategory = exports.timingCategoryToTimeOfUseLabel = exports.getLatestMeterExchangeReading = exports.mostRecentFirst = exports.useWindowDimensions = exports.getReadingTypeLabel = exports.hasRequiredSearchParams = exports.hasSubmittedReadingToday = exports.applyLeadingZeros = void 0;
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var __generated__1 = require("../../../shared/api/kapi/v1/__generated__/");
var submittedReadTypes = [
    'CustomerSubmittedReading',
    'OpeningReadingActual',
];
function applyLeadingZeros(meterNumOfDigits, meterReading) {
    if (!meterNumOfDigits || !String.prototype.padStart) {
        return "".concat(meterReading);
    }
    var _a = __read("".concat(meterReading).split('.'), 2), beforeDecimal = _a[0], afterDecimal = _a[1];
    var paddedValue = beforeDecimal.padStart(meterNumOfDigits, '0');
    if (!afterDecimal) {
        return paddedValue;
    }
    return "".concat(paddedValue, ".").concat(afterDecimal);
}
exports.applyLeadingZeros = applyLeadingZeros;
var hasSubmittedReadingToday = function (readings, msn, sprn) {
    return readings.some(function (read) {
        return submittedReadTypes.includes(read.readingType) &&
            (0, date_fns_1.isToday)(read.formattedReadingDate) &&
            (!sprn || sprn === read.sprn) &&
            (!msn || msn === read.msn);
    });
};
exports.hasSubmittedReadingToday = hasSubmittedReadingToday;
var hasRequiredSearchParams = function (urlSearchParams) {
    //isPending param is optional
    var searchKeys = Array.from(urlSearchParams.keys());
    var commonParams = ['fuel', 'readingDate'];
    var readParams = [
        'meterReading',
        'peakMeterReading',
        'offpeakMeterReading',
        'anytimeMeterReading',
        'heatingMeterReading',
        'eveningAndWeekendMeterReading',
        'solarMeterReading',
        'controlledLoad1MeterReading',
        'controlledLoad2MeterReading',
        'controlledLoad3MeterReading',
        'intervalMeterReading',
    ];
    var hasCommonParams = commonParams.every(function (x) { return searchKeys.includes(x); });
    var hasReadParams = readParams.some(function (x) { return searchKeys.includes(x); });
    return hasCommonParams && hasReadParams;
};
exports.hasRequiredSearchParams = hasRequiredSearchParams;
// See https://ovotech.atlassian.net/wiki/spaces/OEP/pages/4103668315/How+it+works+Meter+reading+type+and+hierarchy
function getReadingTypeLabel(readingType) {
    switch (readingType) {
        case 'CorrectionReadActual':
        case 'CustomerReadingContactCentre':
        case 'CustomerSubmittedReading':
        case 'FinalReadingActual':
        case 'MexReadingFinal':
        case 'MexReadingInitial':
        case 'MigrationReadingActual':
        case 'OnSiteReading':
        case 'OpeningReadingActual':
            return 'Manual';
        case 'MexReadingFinalEstimated':
        case 'MexReadingInitialEstimated':
        case 'MexReadingInitialDeemed':
        case 'OpeningReadingDeemed': //OEA want to validate against this
        case 'OpeningReadingAgreed':
        case 'CorrectionReadEstimate':
        case 'EstimatedReading': //OEA want to validate against this
        case 'MigrationReadingEstimated':
            return 'Estimated';
        case 'SmartReading':
            return 'Smart';
        default:
            return '';
    }
}
exports.getReadingTypeLabel = getReadingTypeLabel;
/* istanbul ignore next */
function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
    };
}
/* istanbul ignore next */
function useWindowDimensions() {
    var _a = __read((0, react_1.useState)(getWindowDimensions()), 2), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowDimensions;
}
exports.useWindowDimensions = useWindowDimensions;
var mostRecentFirst = function (a, b) {
    return (0, date_fns_1.isBefore)(a.formattedReadingDate, b.formattedReadingDate) ? 1 : -1;
};
exports.mostRecentFirst = mostRecentFirst;
function getLatestMeterExchangeReading(readings) {
    var meterExchangeReads = [
        'MexReadingInitial',
        'MexReadingInitialDeemed',
        'MexReadingInitialEstimated',
    ];
    return readings
        .sort(exports.mostRecentFirst)
        .find(function (r) { return meterExchangeReads.includes(r.readingType); });
}
exports.getLatestMeterExchangeReading = getLatestMeterExchangeReading;
var timingCategoryToTimeOfUseLabel = function (timingCategory) {
    switch (timingCategory) {
        case __generated__1.SupplyPointTimingCategory.Anytime:
            return 'anytime';
        case __generated__1.SupplyPointTimingCategory.Peak:
            return 'peak';
        case __generated__1.SupplyPointTimingCategory.OffPeak:
            return 'offpeak';
        case __generated__1.SupplyPointTimingCategory.Shoulder:
            return 'shoulder';
        case __generated__1.SupplyPointTimingCategory.EveningAndWeekend:
            return 'eveningandweekend';
        case __generated__1.SupplyPointTimingCategory.Heating:
            return 'heating';
        case __generated__1.SupplyPointTimingCategory.Solar:
            return 'solar';
        case __generated__1.SupplyPointTimingCategory.ControlledLoad_1:
            return 'controlledload_1';
        case __generated__1.SupplyPointTimingCategory.ControlledLoad_2:
            return 'controlledload_2';
        case __generated__1.SupplyPointTimingCategory.ControlledLoad_3:
            return 'controlledload_3';
        case __generated__1.SupplyPointTimingCategory.Interval:
            return 'interval';
        default:
            return null;
    }
};
exports.timingCategoryToTimeOfUseLabel = timingCategoryToTimeOfUseLabel;
var timeOfUseLabelToTimingCategory = function (timeOfUseLabel) {
    switch (timeOfUseLabel) {
        case 'eveningandweekend':
            return __generated__1.SupplyPointTimingCategory.EveningAndWeekend;
        case 'heating':
            return __generated__1.SupplyPointTimingCategory.Heating;
        case 'offpeak':
            return __generated__1.SupplyPointTimingCategory.OffPeak;
        case 'peak':
            return __generated__1.SupplyPointTimingCategory.Peak;
        case 'anytime':
            return __generated__1.SupplyPointTimingCategory.Anytime;
        case 'controlledload_1':
            return __generated__1.SupplyPointTimingCategory.ControlledLoad_1;
        case 'controlledload_2':
            return __generated__1.SupplyPointTimingCategory.ControlledLoad_2;
        case 'controlledload_3':
            return __generated__1.SupplyPointTimingCategory.ControlledLoad_3;
        case 'solar':
            return __generated__1.SupplyPointTimingCategory.Solar;
        case 'interval':
            return __generated__1.SupplyPointTimingCategory.Interval;
        case 'shoulder':
            return __generated__1.SupplyPointTimingCategory.Shoulder;
        default:
            return null;
    }
};
exports.timeOfUseLabelToTimingCategory = timeOfUseLabelToTimingCategory;
//Has multiple electricity meters across one or more electricity supplies
var hasComplexElec = function (supplies) {
    return supplies.filter(function (supply) { return supply.states.isActive && supply.fuel === 'electricity'; }).length > 1;
};
exports.hasComplexElec = hasComplexElec;
var hasNoActiveSupplies = function (supplies) {
    var hasInactiveElec = supplies.electricity.length
        ? supplies.electricity.every(function (supply) { return !supply.states.isActive; })
        : true;
    var hasInactiveGas = supplies.gas.length
        ? supplies.gas.every(function (supply) { return !supply.states.isActive; })
        : true;
    return hasInactiveElec && hasInactiveGas;
};
exports.hasNoActiveSupplies = hasNoActiveSupplies;
var filterTimeOfUseLabel = function (registers) {
    return !!registers.timeOfUseLabel;
};
exports.filterTimeOfUseLabel = filterTimeOfUseLabel;
var filterSupplies = function (supply) {
    return !!supply.registers;
};
exports.filterSupplies = filterSupplies;
var countMeters = function (supplyMeters) {
    return supplyMeters
        ? Array.from(new Set(supplyMeters.map(function (_a) {
            var msn = _a.msn;
            return msn;
        }).filter(Boolean)))
            .length
        : 0;
};
exports.countMeters = countMeters;
var countSupplies = function (supplyMeters) {
    return supplyMeters
        ? Array.from(new Set(supplyMeters.map(function (_a) {
            var sprn = _a.sprn;
            return sprn;
        }).filter(Boolean)))
            .length
        : 0;
};
exports.countSupplies = countSupplies;
var scrollTo = function (id) {
    var element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};
exports.scrollTo = scrollTo;
var getNextSupplyIndex = function (currentIndex, totalSupplies) {
    // Doesnt have multiple supplies.
    if (totalSupplies < 2) {
        return null;
    }
    // Current not defined, treat as first.
    if (!currentIndex) {
        return 1;
    }
    // Current is the last item, loop back to first.
    if (Number(currentIndex) === totalSupplies - 1) {
        return 0;
    }
    // Current is not the last item, add 1.
    return Number(currentIndex) + 1;
};
exports.getNextSupplyIndex = getNextSupplyIndex;
var getReadingForRegister = function (meterReading, registerId) {
    var tier = meterReading.tiers.find(function (tier) { return tier.registerId === registerId; });
    return tier ? tier.meterRegisterReading : null;
};
var formatPreviousReading = function (registerId, lastActualReading, numOfDigits) {
    if (!lastActualReading) {
        return undefined;
    }
    var reading = getReadingForRegister(lastActualReading, registerId);
    if (reading) {
        return {
            date: lastActualReading.formattedReadingDate,
            value: applyLeadingZeros(numOfDigits, reading),
            isEstimated: getReadingTypeLabel(lastActualReading.readingType) === 'Estimated',
        };
    }
    return undefined;
};
exports.formatPreviousReading = formatPreviousReading;
var hasExpectedReadings = function (readings, registers, readTypes) {
    if (readings.length === 0) {
        return false;
    }
    return registers
        ? hasReadingsForAllRegisters(readings, registers, readTypes)
        : readings.some(function (reading) { return readTypes.includes(reading.readingType); });
};
exports.hasExpectedReadings = hasExpectedReadings;
var hasReadingsForAllRegisters = function (readings, registers, readTypes) {
    var registerIds = registers.map(function (register) { return register.registerId; });
    var readingRegisterIds = readings.reduce(function (acc, reading) {
        return readTypes.includes(reading.readingType)
            ? acc.concat(reading.tiers.map(function (tier) { return tier.registerId; }))
            : acc;
    }, []);
    return registerIds.every(function (id) { return readingRegisterIds.includes(id); });
};
var getReadingsAfter = function (readings, date) {
    return readings.filter(function (reading) { return (0, date_fns_1.isAfter)(reading.formattedReadingDate, date); });
};
exports.getReadingsAfter = getReadingsAfter;
